// Per spec §7.11 + §7.19: vendor-static metadata. Cards + the warm-ink header
// + the per-group meta line consume these fields via useVendorInfo(); App
// provides via VendorInfoProvider after /chat/session resolves.

import { createContext, useContext } from 'react'

export interface VendorInfo {
  business_name: string
  vendor_timezone: string
  // Optional agent name (Direction B handoff). When unset OR set to the
  // backend's "the assistant" sentinel, useVendorInfo's read site falls
  // back to "Mikla" so the warm-ink header never reads "THE ASSISTANT · …".
  agent_name?: string
  // Vendor's booking noun (e.g. "demo meeting"). null/missing = legacy -> "Tour".
  booking_noun?: string | null
}

const VendorInfoContext = createContext<VendorInfo | null>(null)

export const VendorInfoProvider = VendorInfoContext.Provider

export function useVendorInfo(): VendorInfo {
  const ctx = useContext(VendorInfoContext)
  if (!ctx) {
    return { business_name: 'the venue', vendor_timezone: 'America/New_York' }
  }
  return ctx
}

// Resolve the agent name with the widget's "Mikla" default. Backend may emit
// "the assistant" as its last-ditch fallback when the vendor has neither
// voice_agent_config.agent_name nor vendor_info_config.agent_identity.name set;
// we shift that to "Mikla" so the chat reads as part of the Mikla brand voice
// rather than a generic assistant. Anything else flows through verbatim.
export function getAgentName(info: { agent_name?: string }): string {
  const raw = (info.agent_name || '').trim()
  if (!raw || raw.toLowerCase() === 'the assistant') return 'Mikla'
  return raw
}
